import { Component, type ErrorInfo, type ReactNode } from "react";

type RouteErrorBoundaryProps = {
	children: ReactNode;
};

type RouteErrorBoundaryState = {
	error: Error | null;
};

export class RouteErrorBoundary extends Component<
	RouteErrorBoundaryProps,
	RouteErrorBoundaryState
> {
	override state: RouteErrorBoundaryState = { error: null };

	static getDerivedStateFromError(error: Error): RouteErrorBoundaryState {
		return { error };
	}

	override componentDidCatch(error: Error, info: ErrorInfo) {
		console.error("Route render failed:", error, info.componentStack);
	}

	override render() {
		const { error } = this.state;
		if (!error) {
			return this.props.children;
		}

		return (
			<div className="flex min-h-screen flex-col items-center justify-center gap-6 bg-background px-6 text-center">
				<div className="space-y-3">
					<p className="label-micro text-destructive">Cracked casting</p>
					<h2 className="font-display font-wide text-4xl font-extrabold uppercase leading-none tracking-tight">
						Something broke
					</h2>
					<p className="max-w-md text-sm text-muted-foreground">
						{error.message || "An unexpected error stopped this page from rendering."}
					</p>
				</div>
				<div className="flex items-center gap-3">
					<button
						type="button"
						onClick={() => window.location.reload()}
						className="label-micro rounded-sm border border-border px-4 py-2.5 text-foreground/80 transition-colors hover:border-input hover:bg-accent hover:text-foreground"
					>
						Reload page
					</button>
					<a
						href="/agents"
						className="label-micro rounded-sm border border-border px-4 py-2.5 text-foreground/80 transition-colors hover:border-input hover:bg-accent hover:text-foreground"
					>
						Back to agents
					</a>
				</div>
			</div>
		);
	}
}
